import { ErrorInfo } from "react";

const logError = (error: Error, info?: ErrorInfo) => {
  // Do something with the error, e.g. log to an external API
  console.log('name', error.name);
  console.log('message', error.message);
};

export default logError;